/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Math$sign from "@babel/runtime-corejs3/core-js-stable/math/sign";

/** @module core/modules/array-utils/get-shortest-path */

/**
 * @description Determines shortest path from one array position to another.
 * @param {Array<*>} array - Input array.
 * @param {number} from - Starting position.
 * @param {number} to - Ending position.
 * @returns {number} Result.
 */
function getShortestPath(array, from, to) {
  var delta = to % array.length - from;
  var directPathLength = Math.abs(delta);
  var inversePathLength = array.length - directPathLength;

  if (directPathLength <= inversePathLength) {
    return directPathLength * _Math$sign(delta);
  } else {
    return inversePathLength * _Math$sign(delta) * -1;
  }
}

export { getShortestPath };